require('./brokerCustomWalletPortfolio.scss');
const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
const classNames = require('classnames');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ commons
const { Accordion } = require('commonsComponents/accordion');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const { AccordionBody } = require('commonsComponents/accordionBody');
const { OKIconButton } = require('commonsComponents/OKIconButton');
const { LoadingSection } = require('commonsComponents/loadingSection');
// @ components
const BrokerCustomWalletPortfolioSubtitle = require('./brokerCustomWalletPortfolioSubtitle');
const BrokerCustomWalletGroupedPortfolios = require('../brokerCustomWalletGroupedPortfolios/brokerCustomWalletGroupedPortfolios');
const BrokerCustomWalletPortfolioEmptyState =  require('../brokerCustomWalletPortfolioEmptyState/brokerCustomWalletPortfolioEmptyState');
// @ constants
const {
    BROKER_CUSTOM_WALLET_GENERAL_VIEW
}= require('../../constants/index');

class BrokerCustomWalletPortfolio extends React.Component {
    constructor(props) {
        super(props);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleLeaveEditionToEditionModeModal = this.handleLeaveEditionToEditionModeModal.bind(this);
        this.handleLeaveEditionToDeleteModeModal = this.handleLeaveEditionToDeleteModeModal.bind(this);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentDidMount() {
        const { immPortfolio } = this.props;

        if (immPortfolio.get('idPortfolioAccount') === Number(BROKER_CUSTOM_WALLET_GENERAL_VIEW) && !immPortfolio.get('alreadyMergedContracts')) {
            this.props.getDetailsByPortfolio(immPortfolio.get('idPortfolioAccount'));
        }
    }

    buildActionsButton(idPortfolioAccount, isEditable, immSkipLeaveEditionModal) {
        if (!__CONTACT_CENTER__ && isEditable) {
            const { immPortfolio, immGeneralPortfolio, totalContractsCount } = this.props;

            if (immGeneralPortfolio.get('alreadyMergedContracts')) {
                const name = immPortfolio.get('descriptionPortfolioAccount');

                const handleOnClickDelete = () => {
                    this.handleDelete(name);
                }

                const handleOnClickDeleteDisplayModal = () => {
                    this.handleLeaveEditionToDeleteModeModal();
                }

                const handleOnClickEditDisplayModal = () => {
                    this.handleLeaveEditionToEditionModeModal();
                }

                const handleOnClickEdit = () => {
                    this.handleEdit(name);
                }

                const editActionClick = immSkipLeaveEditionModal ? handleOnClickEdit : handleOnClickEditDisplayModal;
                const deleteActionClick = immSkipLeaveEditionModal ? handleOnClickDelete : handleOnClickDeleteDisplayModal;
                const buttonEdit = totalContractsCount ? (
                    <span>
                        <OKIconButton
                            size="small"
                            icon="icon-editar"
                            onClick={editActionClick}
                        />
                    </span>
                ) : null;

                const buttonDelete = (
                    <span>
                        <OKIconButton
                            size="small"
                            icon="icon-eliminar"
                            onClick={deleteActionClick}
                        />
                    </span>
                );

                return (
                    <div className="custom-wallet-portfolio__button-group">
                        {buttonEdit}
                        {buttonDelete}
                    </div>
                );
            }
        }
    }

    buildContractList() {
        const { immPortfolio, immBrokerCustomWalletInterveners } = this.props;
        const contracts = immPortfolio.get('contracts');
        const intervenersByContractId = immBrokerCustomWalletInterveners.get('contractsIntervention');
        let mappedContracts = <LoadingSection />;

        if (immPortfolio.get('alreadyMergedContracts')) {
            if (immPortfolio.get('isCustomWalletContractRequestError')) {
                mappedContracts = <BrokerCustomWalletPortfolioEmptyState />;
            } else {
                mappedContracts = (
                    <BrokerCustomWalletGroupedPortfolios
                        immContracts={contracts}
                        immIntervenersByContractId={intervenersByContractId}
                        editable={false}
                    />
                );
            }
        }

        return (
            <div className="custom-wallet-portfolio__item-list">
                {mappedContracts}
            </div>
        );
    }

    buildHandlerClick(idPortfolioAccount) {
        const { immPortfolio } = this.props;

        return () => {
            if (!immPortfolio.get('alreadyMergedContracts')) {
                this.props.getDetailsByPortfolio(idPortfolioAccount);
            }

            this.props.setExpanded(idPortfolioAccount);
        };
    }

    handleDelete(name) {
        const { immPortfolio } = this.props;
        const idPortfolioAccount = immPortfolio.get('idPortfolioAccount');
        this.props.setPortfolioToDelete(idPortfolioAccount, name);
    }

    handleEdit(name) {
        const { immPortfolio } = this.props;
        const idPortfolioAccount = immPortfolio.get('idPortfolioAccount');
        this.props.setOnEditMode(idPortfolioAccount, name);

        if (!immPortfolio.get('alreadyMergedContracts')) {
            this.props.getDetailsByPortfolio(idPortfolioAccount).then(() => {
                this.props.loadEditablePortfolioById(idPortfolioAccount);
            });
        } else {
            this.props.loadEditablePortfolioById(idPortfolioAccount);
        }
    }

    handleLeaveEditionToDeleteModeModal() {
        const { immPortfolio } = this.props;
        this.props.setOnNextEditMode(immPortfolio);
        this.props.leaveEditionToDelete();
    }

    handleLeaveEditionToEditionModeModal() {
        const { immPortfolio } = this.props;
        this.props.setOnNextEditMode(immPortfolio);
        this.props.leaveEditionToEdition();
    }
    render() {
        const { immPortfolio, immSkipLeaveEditionModal, itsGeneralView, totalContractsCount, totalAlreadyMerged } = this.props;
        const idPortfolioAccount = immPortfolio.get('idPortfolioAccount');
        const viewidPortfolioAccount = immPortfolio.get('viewPortfolioAccount');
        const isExpanded = immPortfolio.get('isExpanded');
        const isEditable = immPortfolio.get('isEditable');
        const contractName = (
            <BrokerCustomWalletPortfolioSubtitle
                immPortfolio={immPortfolio}
                totalContractsCount={totalContractsCount}
                totalAlreadyMerged={totalAlreadyMerged}
                isDefaultView={false}
            />
        );

        const accordionHeaderClass = classNames({
            'custom-wallet-portfolio': true,
            'is-expanded': isExpanded || itsGeneralView
        });

        const onPortfolioClick = this.buildHandlerClick(idPortfolioAccount);

        return (
            <Accordion
                customClassName={accordionHeaderClass}
                isExpanded={isExpanded}
                onClick={onPortfolioClick}>
                <AccordionHeader name="AccordionHeader">
                    {contractName}
                    {this.buildActionsButton(viewidPortfolioAccount, isEditable, immSkipLeaveEditionModal)}
                </AccordionHeader>
                <AccordionBody name="AccordionBody">
                    {this.buildContractList()}
                </AccordionBody>
            </Accordion>
        );
    }
}

BrokerCustomWalletPortfolio.propTypes = {
    immBrokerCustomWalletInterveners: PropTypes.object.isRequired,
    immSkipLeaveEditionModal: PropTypes.bool,
    immNamePortfolioOnEdition: PropTypes.string,
    immPortfolio: PropTypes.any.isRequired,
    immGeneralPortfolio: PropTypes.any.isRequired,
    getDetailsByPortfolio: PropTypes.func.isRequired,
    setPortfolioToDelete: PropTypes.func.isRequired,
    leaveEditionToDelete: PropTypes.func.isRequired,
    leaveEditionToEdition: PropTypes.func.isRequired,
    setOnEditMode: PropTypes.func.isRequired,
    setOnNextEditMode: PropTypes.func.isRequired,
    loadEditablePortfolioById: PropTypes.func.isRequired,
    setExpanded: PropTypes.func.isRequired,
    itsGeneralView: PropTypes.bool,
    getContractsList: PropTypes.func,
    totalContractsCount: PropTypes.number,
    totalAlreadyMerged: PropTypes.bool
};

module.exports = BrokerCustomWalletPortfolio;
